// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1oDLK","paramInput":"JobSimulator_paramInput__1imhF","input":"JobSimulator_input__-5Z3A"};